// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RichTextEditor_rich-text-editor-container__wcoK6 {
  width: 100%;
  position: relative;
  margin-bottom: 15px;
}
.RichTextEditor_rich-text-editor-container__reading__eUdru {
  padding: 8px;
  border-radius: 4px;
  line-height: 32px;
  overflow-y: auto;
}
.RichTextEditor_rich-text-editor-container__reading__eUdru:not(.RichTextEditor_rich-text-editor-container__reading--read-only__-AOkj):hover {
  background-color: var(--m-subtle-light);
}
.RichTextEditor_rich-text-editor-container__reading--border__ckuPN {
  border: var(--m-default-border);
  height: 40px;
  padding: unset;
  display: flex;
  align-items: center;
  padding-left: 16px;
  opacity: 0.6;
}
.RichTextEditor_rich-text-editor-container__reading__eUdru p {
  font-size: 14px;
  font-weight: normal;
  line-height: 30px;
}
.RichTextEditor_rich-text-editor-container__reading__eUdru a {
  color: #0065FF;
  text-decoration: none;
}
.RichTextEditor_rich-text-editor-container__reading__eUdru a:hover {
  text-decoration: underline;
}
.RichTextEditor_rich-text-editor-container__reading__eUdru img {
  width: 200px;
}
.RichTextEditor_rich-text-editor-container__reading__eUdru ul {
  padding-left: 20px;
}
.RichTextEditor_rich-text-editor-container__reading__eUdru ol {
  padding-left: 30px;
}
.RichTextEditor_rich-text-editor-container__reading__eUdru .RichTextEditor_image-container__tgpLX {
  position: relative;
  display: inline-block;
}
.RichTextEditor_rich-text-editor-container__reading__eUdru .RichTextEditor_image-container__tgpLX .RichTextEditor_resize__X3sFV {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 10px;
  height: 100%;
  background-color: tomato;
  cursor: col-resize;
}
.RichTextEditor_rich-text-editor-container__reading__eUdru blockquote {
  box-sizing: border-box;
  padding-left: 16px;
  border-left: 2px solid #D0D5DD;
  margin: 0.75rem 0px;
}
.RichTextEditor_rich-text-editor-container__reading__eUdru code {
  cursor: text;
  color: #172B4D;
  border-radius: 3px;
  font-size: 14px;
  line-height: 24px;
  background-color: #eceff1;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 8px;
  overflow-wrap: break-word;
  white-space: pre-wrap;
  margin: 0.75rem 0px;
  min-height: 40px;
}`, "",{"version":3,"sources":["webpack://./src/components/CustomUI/RichTextEditor/RichTextEditor.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,kBAAA;EACA,mBAAA;AACJ;AACI;EACI,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;AACR;AAEY;EACI,uCAAA;AAAhB;AAIQ;EACI,+BAAA;EACA,YAAA;EACA,cAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,YAAA;AAFZ;AAKQ;EACI,eAAA;EACA,mBAAA;EACA,iBAAA;AAHZ;AAMQ;EACI,cAAA;EACA,qBAAA;AAJZ;AAMY;EACI,0BAAA;AAJhB;AAQQ;EACI,YAAA;AANZ;AASQ;EACI,kBAAA;AAPZ;AAUQ;EACI,kBAAA;AARZ;AAWQ;EACI,kBAAA;EACA,qBAAA;AATZ;AAWY;EACI,kBAAA;EACA,SAAA;EACA,QAAA;EACA,WAAA;EACA,YAAA;EACA,wBAAA;EACA,kBAAA;AAThB;AAaQ;EACI,sBAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;AAXZ;AAcQ;EACI,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,WAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,mBAAA;EACA,gBAAA;AAZZ","sourcesContent":[".rich-text-editor-container {\n    width: 100%;\n    position: relative;\n    margin-bottom: 15px;\n\n    &__reading {\n        padding: 8px;\n        border-radius: 4px;\n        line-height: 32px;\n        overflow-y: auto;\n        \n        &:not(.rich-text-editor-container__reading--read-only) {\n            &:hover {\n                background-color: var(--m-subtle-light);\n            }\n        }\n\n        &--border {\n            border: var(--m-default-border);\n            height: 40px;\n            padding: unset;\n            display: flex;\n            align-items: center;\n            padding-left: 16px;\n            opacity: 0.6;\n        }\n\n        p {\n            font-size: 14px;\n            font-weight: normal;\n            line-height: 30px;\n        }\n        \n        a {\n            color:  #0065FF;\n            text-decoration: none;\n        \n            &:hover {\n                text-decoration: underline;\n            }\n        }\n        \n        img {\n            width: 200px;\n        }\n        \n        ul {\n            padding-left: 20px;\n        }\n        \n        ol {\n            padding-left: 30px;\n        }\n        \n        .image-container {\n            position: relative;\n            display: inline-block;\n    \n            .resize {\n                position: absolute;\n                bottom: 0;\n                right: 0;\n                width: 10px;\n                height: 100%;\n                background-color: tomato;\n                cursor: col-resize;\n            }\n        }\n        \n        blockquote {\n            box-sizing: border-box;\n            padding-left: 16px;\n            border-left: 2px solid #D0D5DD;\n            margin: 0.75rem 0px;\n        }\n        \n        code {\n            cursor: text;\n            color: #172B4D;\n            border-radius: 3px;\n            font-size: 14px;\n            line-height: 24px;\n            background-color: #eceff1;\n            width: 100%;\n            display: flex;\n            flex-direction: column;\n            padding: 8px;\n            overflow-wrap: break-word;\n            white-space: pre-wrap;\n            margin: 0.75rem 0px;\n            min-height: 40px;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rich-text-editor-container": `RichTextEditor_rich-text-editor-container__wcoK6`,
	"rich-text-editor-container__reading": `RichTextEditor_rich-text-editor-container__reading__eUdru`,
	"rich-text-editor-container__reading--read-only": `RichTextEditor_rich-text-editor-container__reading--read-only__-AOkj`,
	"rich-text-editor-container__reading--border": `RichTextEditor_rich-text-editor-container__reading--border__ckuPN`,
	"image-container": `RichTextEditor_image-container__tgpLX`,
	"resize": `RichTextEditor_resize__X3sFV`
};
export default ___CSS_LOADER_EXPORT___;
